import { SpritesService } from "@ulaval/modul-components";
import Vue, { PluginObject, VueConstructor } from "vue";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IconPlugin: PluginObject<any> = {
  install(v: VueConstructor<Vue>): void {
    const svg: SpritesService = v.prototype.$svg;
    svg.addExternalSprites(
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      require("@ulaval/modul-components/dist/assets/icons/sprites-default.svg"),
      "m"
    );
  },
};

export default IconPlugin;
